// Ensures every question's oeparameters.isRequired is always persisted as an
// explicit boolean (true/false) instead of being omitted. Keeps the Raw JSON
// preview and the saved survey payload consistent — an unchecked "Required"
// checkbox must serialize as `isRequired: false`, not disappear.
export const normalizeRequiredFlags = (data) => {
  const normalized = {};
  Object.entries(data || {}).forEach(([key, question]) => {
    const oe = question?.oeparameters;
    normalized[key] = {
      ...question,
      oeparameters: {
        ...(oe || {}),
        isRequired: typeof oe?.isRequired === "boolean" ? oe.isRequired : true,
      },
    };
  });
  return normalized;
};